<div class="cupon">
  @if(!isCuponClicked){
  <div (click)="onCuponClicked()">{{ ApplyCoupon() }}</div>
  } @else {
  <input
    type="text"
    class="input_code"
    [(ngModel)]="userInput"
    (keydown.enter)="onEnter()"
  />
  }
</div>

@if(isCuponClicked){
<div class="conditions">
  @if(language == 'Tr'){
  <div class="question">
    {{ Coupon() }} <span class="gold">{{ Code() }}</span> {{ HowToGet() }}
  </div>
  } @else if(language == 'Ar'){
  <div class="question question--ar">
    كيفية الحصول على <span class="gold">{{ Coupon() }}</span> {{ Code() }}
  </div>
  } @else {
  <div class="question">
    {{ HowToGet() }}<span class="gold">{{ Coupon() }}</span> {{ Code() }}
  </div>
  }
  @if(language == 'Ar'){
    <div class="condition condition--ar">
      <div>{{ Condition1() }}</div>
      <svg class="icon" (click)="goToGoogle()">
        <use xlink:href="images/sprites.svg#icon-road"></use>
      </svg>
    </div>
    <div class="condition condition--ar">
      <div>{{ Condition2() }}</div>
      <svg class="icon" (click)="goToInsta()">
        <use xlink:href="images/sprites9.svg#icon-instagram"></use>
      </svg>
      <div class="insta">aradaistanbul</div>
    </div>
    <div class="condition condition--ar">
      <div>{{ Condition3() }}</div>
    </div>
  } @else {
    <div class="condition">
      <div>{{ Condition1() }}</div>
      <svg class="icon" (click)="goToGoogle()">
        <use xlink:href="images/sprites.svg#icon-road"></use>
      </svg>
    </div>
    <div class="condition">
      <div>{{ Condition2() }}</div>
      <svg class="icon" (click)="goToInsta()">
        <use xlink:href="images/sprites9.svg#icon-instagram"></use>
      </svg>
      <div class="insta">aradaistanbul</div>
    </div>
    <div class="condition">
      <div>{{ Condition3() }}</div>
    </div>
  }

</div>

}
